import { mapReferenceDtoToReference, mapReferenceToDto, Reference, GuidelineReferenceDto } from '@treetop/shared/model';

export enum GuidelineElementSection {
  Default = 1,
  Description = 2,
  SecondDescription = 3,
}

export enum GuidelineElementType {
  Header = 1,
  Chapter = 2,
  Component = 3,
  FlowchartElement = 4,
}

export const mapGuidelineReferenceDtoToReference = (dto: GuidelineReferenceDto): Reference => mapReferenceDtoToReference(dto.reference);

export const mapReferenceToGuidelineReferenceDto = (reference: Reference): GuidelineReferenceDto => ({
  reference: mapReferenceToDto(reference),
  id: crypto.randomUUID(),
});
